import { render, staticRenderFns } from "./SortByDropdown.vue?vue&type=template&id=794ae75a&scoped=true&"
import script from "./SortByDropdown.vue?vue&type=script&lang=js&"
export * from "./SortByDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794ae75a",
  null
  
)

export default component.exports